import {
  type CountryCode,
  getCountryCallingCode,
  parsePhoneNumberFromString,
} from "libphonenumber-js";

/**
 * Parses a phone string (E.164 like +91… or national digits) and returns display
 * parts for marketing UI. Uses `defaultCountry` when the number has no country prefix.
 */
export function parsePhoneForMarketingDisplay(
  phoneNumber: string,
  options?: { defaultCountry?: CountryCode }
): {
  /** ISO 3166-1 alpha-2 for flag assets */
  iso: string;
  /** e.g. "+91" */
  callingCodeLabel: string;
  nationalNumber: string;
} {
  const defaultCountry: CountryCode = options?.defaultCountry ?? "IN";
  const defaultCalling = `+${getCountryCallingCode(defaultCountry)}`;
  const trimmed = phoneNumber?.trim() ?? "";
  if (!trimmed) {
    return {
      iso: defaultCountry,
      callingCodeLabel: defaultCalling,
      nationalNumber: "",
    };
  }

  const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
  if (!parsed) {
    const digits = trimmed.replace(/\D/g, "");
    return {
      iso: defaultCountry,
      callingCodeLabel: defaultCalling,
      nationalNumber: digits || trimmed,
    };
  }

  const iso = parsed.country ?? defaultCountry;
  return {
    iso,
    callingCodeLabel: `+${parsed.countryCallingCode}`,
    nationalNumber: parsed.nationalNumber,
  };
}
